<template>
  <form class="w-100" @submit.prevent="submit">
    <div class="row">
      <div class="col-12 text-left">
        <button v-if="id !== 'new'" @click="del" type="button" class="btn btn-danger">
          حذف نظر
          <i class="fas fa-trash"/>
        </button>
        <button type="submit" class="btn btn-success mr-2">
          <span v-if="id !== 'new'">
            بروزرسانی نظر
          <i class="far fa-save"/>
          </span>
          <!--          <span v-else>-->
          <!--            افزودن نظر-->
          <!--                <i class="fas fa-plus"/>-->
          <!--          </span>-->
        </button>

        <hr>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-info" slot="header">
            <i class="fas fa-clock"/>
          </div>
          <div class="text-right" slot="content">
            <p><b>تاریخ</b></p>
            {{$dateTimeFormat(item.created_at)}}
          </div>
        </StatsCard>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div class="icon-big text-center icon-primary" slot="header">
            <i class="far fa-kiss-beam"/>
          </div>
          <div class="text-right" slot="content">
            <router-link v-if="item.ref_type === 'STORY'" :to="{name: 'edit_story', params: {id: item.ref_id}}">
              <p><b> {{$typeToPersian(item.ref_type)}}</b></p>

              {{refObj.title}}
            </router-link>
          </div>
        </StatsCard>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard>
          <div
              :class="`icon-big text-center icon-${item.is_verified ? 'success' :  item.is_verified === undefined ? 'warning' : 'danger' }`"
              slot="header">
            <i v-if="item.is_verified" class="far fa-check-circle"/>
            <i v-else-if="item.is_verified === false" class="far fa-times-circle"/>
            <i v-else-if="item.is_verified === null || item.is_verified === undefined" class="fas fa-clock"/>
          </div>
          <div class="text-right" slot="content">
            <p><b>وضعیت</b></p>
            <div v-if="item.is_verified">تایید شده</div>
            <div v-else-if="item.is_verified === false">تایید نشده</div>
            <div v-else-if="item.is_verified === null || item.is_verified === undefined">در انتظار تایید</div>
          </div>
        </StatsCard>
      </div>
      <div v-if="id !== 'new'" class="col-12 col-sm-6 col-lg-3">
        <StatsCard v-if="item.account && Object.keys(item.account).length > 0">
          <div class="icon-big text-center icon-warning" slot="header">
            <i class="far fa-user"/>
          </div>
          <div class="text-right" slot="content">
            <router-link :to="{name: 'edit_user', params: {id: item.account.id}}">
              <p><b>کاربر</b></p>

              {{item.account.username}}

              <br/>
              <small dir="ltr">{{item.account.mobile}}</small>
            </router-link>
          </div>
        </StatsCard>
      </div>

      <div v-if="id === 'new'  || ( Object.keys(item).length  )" class="col-12">

        <div class="row">
          <div class="col-12">
            <card class="card" title="نظر">
              <div>
                <div class="form-row">
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="form-group text-right">
                      <div class="form-group text-right">
                        <label for="status">مورد تایید است؟</label>
                        <fv-switch id="status" class="form-control d-block" placeholder="مورد تایید است؟"
                                   v-model="item.is_verified"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="form-group text-right">
                      <label for="enable">فعال</label>
                      <fv-switch id="enable" class="form-control d-block" placeholder="فعال"
                                 v-model="item.enabled"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="form-group text-right">
                      <label for="edit">تغییر محتوا نظر</label>
                      <fv-switch @input="disableEditor = !disableEditor" id="edit" class="form-control d-block"
                                 placeholder="تغییر محتوا نظر" :value="!disableEditor"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="form-group text-right">
                      <label for="order">ترتیب</label>
                      <input id="order" type="number" class="form-control" placeholder="ترتیب"
                             v-model.number="item.order">
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="comment">نظر</label>
                      <textarea class="form-control" rows="3" id="comment" placeholder="نظر" :disabled="disableEditor"
                                v-model="item.content"/>
                    </div>
                  </div>
                </div>
                <div class="clearfix"/>
              </div>
            </card>
            <card class="card" title="پاسخ‌ها به این نظر">
              <div v-for="val in item.children" class="mb-5">
                <div class="form-row text-right">
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="mb-1">متن پاسخ داده‌شده</div>
                    <div>
                      {{val.content}}
                    </div>
                  </div>
                  <div class="col-12 col-lg-3 mb-3">
                    <button class="btn btn-warning"
                            type="button"
                            @click="$router.push({name: 'edit_comment' , params: {id: val.id}})">
                      مشاهده صفحه‌پاسخ
                      <i class="far fa-edit"/>
                    </button>
                  </div>
                  <div class="col-12 col-lg-3 mb-3" v-if="val.account.id">
                    <div class="mb-1">کاربر پاسخ دهنده</div>
                    <router-link :to="{name: 'edit_user' , params: {id: val.account.id}}">
                      {{val.account.name}} {{val.account.family_name}} {{val.account.roles.indexOf('admin') !== -1 ?
                      '(ادمین)' : ''}}
                    </router-link>
                  </div>
                  <div class="col-12 col-lg-3 mb-3">
                    <div class="mb-1">تاریخ پاسخ</div>
                    <div>
                      {{$dateTimeFormat(val.created_at)}}
                    </div>
                  </div>
                </div>
                <hr/>
              </div>
              <div v-if="showReply" class="mb-5">
                <div class="form-row text-right d-flex align-items-center">
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <label for="replyContent">متن پاسخ</label>
                      <textarea class="form-control"
                                rows="3"
                                id="replyContent"
                                placeholder="متن پاسخ"
                                v-model="replyContent"/>
                    </div>
                  </div>
                  <div class="col-12 col-lg-4 mb-3">
                    <div class="form-group text-right">
                      <button type="button"
                              @click="postReply"
                              class="btn btn-success mr-2">ثبت پاسخ
                      </button>
                    </div>
                  </div>
                </div>
                <hr/>
              </div>
              <div>
                <button type="button"
                        @click="addReply"
                        class="btn btn-info mr-2">
                  اضافه کردن پاسخ
                </button>
              </div>
            </card>
          </div>
        </div>
      </div>


    </div>
  </form>
</template>
<script>
	import Modela from 'modela'
	import commentModel from "../../models/comments"
	import {mapActions} from "vuex"
	import {StatsCard} from "@/components/index";
	import versionModel from "../../models/versions";

	export default {
		name: 'edit_comment',
		components: {

			StatsCard,
		},
		data() {
			const {params} = this.$route
			const {id} = params
			return {
				...mapActions('main', [
					'crud'
				]),
				id,
				item: {},
				disableEditor: id !== 'new',
				refObj: {},
        replyContent: null,
        showReply :false,
			}
		},
		methods: {
			async getData() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const comment = await this.crud({
						action: 'get',
						section: 'comments',
						id: this.id,
						showError: true
					})
					if (comment.data) {
						const result = comment.data
						let item = new Modela(commentModel)
						item = item.$clean()
						item = item.$set(result)
						this.item = item.$clean().$export()

						if (item.ref_type === 'STORY' && item.ref_id) {
							const story = await this.crud({
								action: 'get',
								section: 'stories',
								id: item.ref_id,
							})
							this.refObj = story.data
						}
					}

				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async post() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const newComment = await this.crud({
						action: 'post',
						section: 'comments',
						data: this.item,
						showError: true
					})
					this.$successAlert()
					this.$router.go(-1)
					// await this.$router.push({name: 'comments'})
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}

			},
			async put() {
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const updateComment = await this.crud({
						action: 'put',
						section: 'comments',
						id: this.id,
						data: this.item,
						showError: true
					})
					this.$successAlert()
					this.$router.go(-1)
					// await this.$router.push({name: 'comments'})
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}

			},
			async del() {
				if (!await this.$confirmAlert())
					return false
				try {
					this.$store.commit('main/SET', {key: 'loading', value: true})
					const deleted = await this.crud({
						action: 'delete',
						section: 'comments',
						id: this.id,
						showError: true
					})
					await this.$successAlert()
					// await this.$router.push({name: 'comments'})
					this.$router.go(-1)
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async submit() {
				if (this.id !== 'new')
					this.put()
				else
					this.post()
			},
      addReply(){
				this.showReply = true
      },
			async postReply() {
				try {
					if(!this.replyContent)
						return

					this.$store.commit('main/SET', {key: 'loading', value: true})
          let url
          if(this.item.ref_type === 'STORY')
          	url = `stories/${this.item.ref_id}/comments`

					const newReply = await this.crud({
						action: 'post',
						section: url,
						data: {
							content: this.replyContent,
              parent_id : this.item.id
            },
						showError: true
					})

					await this.getData()
          this.$successAlert()
					this.showReply = false
					this.replyContent = null

				} catch (e) {
					console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},

		},
		created() {
			if (this.id !== 'new')
				this.getData()
			else {
				let item = new Modela(commentModel)
				this.item = item.$clean().$export()
			}
		},
		watch: {
			'$route.params'(val) {
				this.id = val.id
				if (val.id !== 'new')
					this.getData()
				else {
					let item = new Modela(commentModel)
					this.item = item.$clean().$export()
				}
			}
		},
	};
</script>
<style>
</style>
